
<span *ngIf="timeTrackingType === TimeTrackingTypeEnum.ACT48">
     <!-- Emergency Cert Indicator -->
     <div class="a_circle para enabled"
          *ngIf="isEmergencyCert()"
          edlTooltip="Emergency Cert"
          [edlTooltipConfig]="{shouldTriggerOnKeydown: false}"
          placement="left"
          tabindex="0"
          [attr.id]="emergencyPopoverId"
          [attr.aria-label]="'Emergency Certification'"
          [attr.aria-describedby]="isPopoverActive(emergencyPopoverId) ? emergencyPopoverId + '-tooltip' : null"
          [attr.aria-expanded]="isPopoverActive(emergencyPopoverId)"
          [attr.aria-haspopup]="true"
          [attr.role]="getAriaRole()"
          (mouseenter)="onTooltipMouseEnter(emergencyTooltip, emergencyPopoverId)"
          (mouseleave)="onTooltipMouseLeave(emergencyPopoverId)"
          (focus)="onTooltipFocus(emergencyTooltip, emergencyPopoverId)"
          (blur)="onTooltipBlur(emergencyPopoverId)"
          (keydown)="onTooltipKeyDown($event, emergencyTooltip, emergencyPopoverId)">
          E
     </div>

     <!-- Paraeducator Status Indicator -->
     <div class="a_circle para enabled"
          *ngIf="isParaApplicable()"
          edlTooltip="Paraeducator Status: {{getStatusDescription(paraStatusId)}}"
          [edlTooltipConfig]="{shouldTriggerOnKeydown: false}"
          placement="left"
          tabindex="0"
          [attr.id]="paraPopoverId"
          [attr.aria-label]="'Paraeducator Hours Status: ' + getStatusDescription(paraStatusId)"
          [attr.aria-describedby]="isPopoverActive(paraPopoverId) ? paraPopoverId + '-tooltip' : null"
          [attr.aria-expanded]="isPopoverActive(paraPopoverId)"
          [attr.aria-haspopup]="true"
          [attr.role]="getAriaRole()"
          [attr.aria-live]="paraStatusId === A48UserStatus.ERROR ? 'assertive' : 'polite'"
          [class.default]="paraStatusId === A48UserStatus.NOACTION"
          [class.pending]="paraStatusId === A48UserStatus.PENDING"
          [class.success]="paraStatusId === A48UserStatus.PARAAPPROVED"
          (mouseenter)="onTooltipMouseEnter(paraTooltip, paraPopoverId)"
          (mouseleave)="onTooltipMouseLeave(paraPopoverId)"
          (focus)="onTooltipFocus(paraTooltip, paraPopoverId)"
          (blur)="onTooltipBlur(paraPopoverId)"
          (keydown)="onTooltipKeyDown($event, paraTooltip, paraPopoverId)">
          P
     </div>

     <!-- Main Act 48 Status Indicator -->
     <div class="a_circle enabled text-center a48-status-indicator"
          edlTooltip="Act 48 Status: {{statusLabel ?? 'None'}}"
          [edlTooltipConfig]="{shouldTriggerOnKeydown: false}"
          tabindex="0"
          [attr.id]="mainPopoverId"
          [attr.aria-label]="getAccessibleStatusText()"
          [attr.aria-describedby]="isPopoverActive(mainPopoverId) ? mainPopoverId + '-tooltip' : null"
          [attr.aria-expanded]="isPopoverActive(mainPopoverId)"
          [attr.aria-haspopup]="true"
          [attr.role]="getAriaRole()"
          [attr.aria-live]="getAriaLive()"
          [class.default]="statusId === A48UserStatus.NOACTION"
          [class.override]="statusId === A48UserStatus.OVERRIDE"
          [class.pending]="statusId === A48UserStatus.PENDING"
          [class.error]="statusId === A48UserStatus.ERROR"
          [class.success]="statusId === A48UserStatus.SUCCESS"
          [class.excluded]="statusId === A48UserStatus.EXCLUDED"
          [class.clickable]="canOpenModal"
          (click)="handleClick($event)"
          (mouseenter)="onTooltipMouseEnter(mainTooltip, mainPopoverId)"
          (mouseleave)="onTooltipMouseLeave(mainPopoverId)"
          (focus)="onTooltipFocus(mainTooltip, mainPopoverId)"
          (blur)="onTooltipBlur(mainPopoverId)"
          (keydown)="onTooltipKeyDown($event, mainTooltip, mainPopoverId)">
          <edl-icon name="clock" [ariaHidden]="true" [size]="18"></edl-icon>
     </div>
</span>

<span *ngIf="timeTrackingType === TimeTrackingTypeEnum.FLEX" >
     <!-- Main Flex Status Indicator -->
    <div class="a_circle enabled text-center timetracking-status-indicator"
          edlTooltip="{{statusLabel}}"
          [edlTooltipConfig]="{shouldTriggerOnKeydown: false}"
          placement="top"
          tabindex="0"
          [attr.id]="mainPopoverId"
          [attr.aria-label]="getAccessibleStatusText()"
          [attr.aria-describedby]="isPopoverActive(mainPopoverId) ? mainPopoverId + '-tooltip' : null"
          [attr.aria-expanded]="isPopoverActive(mainPopoverId)"
          [attr.aria-haspopup]="true"
          [attr.role]="getAriaRole()"
          [attr.aria-live]="getAriaLive()"
          [class.default]="statusId === A48UserStatus.NOACTION"
          (mouseenter)="onTooltipMouseEnter(mainTooltip, mainPopoverId)"
          (mouseleave)="onTooltipMouseLeave(mainPopoverId)"
          (focus)="onTooltipFocus(mainTooltip, mainPopoverId)"
          (blur)="onTooltipBlur(mainPopoverId)"
          (keydown)="onTooltipKeyDown($event, mainTooltip, mainPopoverId)">
          <edl-icon name="clock" [ariaHidden]="true" [size]="18"></edl-icon>
     </div>
</span>
<small *ngIf="showHours">({{HoursLabel}})</small>